import {useEffect, useState} from "react";
import collapse_arrow from "../assets/collapse.svg"
import expand_arrow from "../assets/expand-teams.svg"
import {useNavigate} from "react-router-dom";


const FAQContainer = (props) => {
    const FAQ = props.question
    const idx = props.idx
    const [expand, setExpand] = useState(false)
    const [arrow, setArrow] = useState(expand_arrow)
    const navigate = useNavigate();

    useEffect(() => {
        if (arrow === expand_arrow) {setArrow(collapse_arrow)} else {setArrow(expand_arrow)}
    }, [expand])


    return(
        <div className="faq-container" key={`faq-${idx}`}>
            <div className="faq-question-container">
                <div className="faq-question-text">{FAQ.question}</div>
                <div className="get-in-touch-dropdown-row-button link" id="faq-row-1" onClick={() => setExpand(!expand)}>
                    {expand ? "-" : "+"}
                </div>
            </div>
            {expand ?
                <div className="faq-answer-container">
                    {FAQ.answer && FAQ.answer.map((text, idy) => {
                        if (text.type === "text") {
                            return(
                                <div className="faq-answer-text-container" key={idy}>{text.text}</div>
                            )
                        } else if (text.type === "internal_link") {
                            return(
                                <div className="faq-answer-text-container" key={idy}>
                                    {text.text} &thinsp;
                                    <a className="faq-link-text" onClick={() => navigate(text.link)}>
                                        {text.link_text}
                                    </a>
                                    {text.after_text}
                                </div>
                            )
                        } else {
                            return(
                                <div className="faq-answer-text-container" key={idy}>
                                    {text.text} &thinsp;
                                    <a className="faq-link-text" href={text.link}>
                                        {text.link_text}
                                    </a>
                                    {text.after_text}
                                </div>
                            )
                        }

                    })}
                    {FAQ.link && FAQ.link.map((item, idy) => {

                    })}
                </div>
                :null}
        </div>
    )
}

export default FAQContainer